import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getOrderGeneratorsFieldsWorksPlanWorks(companyId, generatorId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].getOrderGeneratorsFieldsWorksPlanWorks,
		{
			urlParams: {
				companyId,
				generatorId,
			},
		}
	)
}

function getOrderGeneratorsFieldsWorksPlanWork(companyId, generatorId, planWorkId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].getOrderGeneratorsFieldsWorksPlanWork,
		{
			urlParams: {
				companyId,
				generatorId,
				planWorkId,
			},
		}
	)
}

function getOrderGeneratorsFieldsWorksPlanWorksRelatedPlanWorks(companyId, generatorId, planWorkId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].getOrderGeneratorsFieldsWorksPlanWorksRelatedPlanWorks,
		{
			urlParams: {
				companyId,
				generatorId,
				planWorkId,
			},
		}
	)
}

function createOrderGeneratorsFieldsWorksPlanWork(companyId, generatorId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].createOrderGeneratorsFieldsWorksPlanWork,
		{
			urlParams: {
				companyId,
				generatorId,
			},
			...payload,
		}
	)
}

function createOrderGeneratorsFieldsWorksPlanWorkBulk(companyId, generatorId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].createOrderGeneratorsFieldsWorksPlanWorkBulk,
		{
			urlParams: {
				companyId,
				generatorId,
			},
			...payload,
		}
	)
}

function putOrderGeneratorsFieldsWorksPlanWork(companyId, generatorId, planWorkId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].putOrderGeneratorsFieldsWorksPlanWork,
		{
			urlParams: {
				companyId,
				generatorId,
				planWorkId,
			},
			...payload,
		}
	)
}

function patchOrderGeneratorsFieldsWorksPlanWork(companyId, generatorId, planWorkId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].patchOrderGeneratorsFieldsWorksPlanWork,
		{
			urlParams: {
				companyId,
				generatorId,
				planWorkId,
			},
			...payload,
		}
	)
}

function deleteOrderGeneratorsFieldsWorksPlanWork(companyId, generatorId, planWorkId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].deleteOrderGeneratorsFieldsWorksPlanWork,
		{
			urlParams: {
				companyId,
				generatorId,
				planWorkId,
			},
		}
	)
}

function getOrderGeneratorsFieldsWorksPlanWorkPreview(companyId, generatorId, planWorkId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].getOrderGeneratorsFieldsWorksPlanWorkPreview,
		{
			urlParams: {
				companyId,
				generatorId,
				planWorkId,
			},
		}
	)
}

function getOrderGeneratorsFieldsWorksPlanWorkPopup(companyId, generatorId, planWorkId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].getOrderGeneratorsFieldsWorksPlanWorkPopup,
		{
			urlParams: {
				companyId,
				generatorId,
				planWorkId,
			},
		}
	)
}

export default {
	getOrderGeneratorsFieldsWorksPlanWorks,
	getOrderGeneratorsFieldsWorksPlanWork,
	getOrderGeneratorsFieldsWorksPlanWorksRelatedPlanWorks,
	createOrderGeneratorsFieldsWorksPlanWork,
	createOrderGeneratorsFieldsWorksPlanWorkBulk,
	putOrderGeneratorsFieldsWorksPlanWork,
	patchOrderGeneratorsFieldsWorksPlanWork,
	deleteOrderGeneratorsFieldsWorksPlanWork,
	getOrderGeneratorsFieldsWorksPlanWorkPreview,
	getOrderGeneratorsFieldsWorksPlanWorkPopup,
}
